import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en/translation.json';
import es from './locales/es/translation.json';

// i18next v26 has built-in browser language detection that reads navigator.language.
// We disable it completely so the phone's OS language (e.g. Spanish) cannot override us.
// English is ALWAYS the default. Spanish is only set by the user clicking the ES toggle.
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    lng: 'en',
    fallbackLng: 'en',
    detection: undefined,          // kill any built-in detector
    load: 'languageOnly',          // ignore region variants (e.g. es-ES → es)
    nonExplicitSupportedLngs: false,
    interpolation: {
      escapeValue: false,
    },
  });

// Lock it in immediately — prevents any async detector from overriding after init
i18n.changeLanguage('en');

export default i18n;
